import { Icon } from '@/components/Icon';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { cn } from '@/lib/utils';
import type { UsageBanner as Banner } from './usageModel';

const TONE: Record<Banner['tone'], { icon: string; className: string; iconClassName: string }> = {
  destructive: { icon: 'block', className: '', iconClassName: '' },
  warning: { icon: 'warning', className: 'border-awaiting/30 bg-awaiting/10 text-foreground [&_[data-slot=alert-description]]:text-foreground/80', iconClassName: 'text-awaiting' },
  info: { icon: 'info', className: 'border-running/30 bg-running/10 text-foreground [&_[data-slot=alert-description]]:text-foreground/80', iconClassName: 'text-running' },
};

/** The one message the page leads with: new builds paused, an override in force, over the plan, or nearing it. */
export function UsageBannerView({ banner }: { banner: Banner }) {
  const tone = TONE[banner.tone];
  return (
    <Alert data-testid="usage-banner" data-tone={banner.tone} variant={banner.tone === 'destructive' ? 'destructive' : 'default'} className={cn('enter', tone.className)}>
      <AlertTitle className="col-start-1 col-end-3 flex items-center gap-2">
        <Icon name={tone.icon} size={18} className={tone.iconClassName} />
        {banner.title}
      </AlertTitle>
      <AlertDescription className="col-start-1 col-end-3">{banner.description}</AlertDescription>
    </Alert>
  );
}
